import { apiRequest } from "./client"

export interface WaiterListItem {
  id: number
  username: string
  ime: string
  prezime: string
}

export interface LoginResponse {
  sessionToken: string
  korisnikId: number
  ime: string
  prezime: string
  companyId: number
  companyName: string
  poslovnaJedinicaId?: number
  kasaId?: number
  sessionPrinterId?: number
  moraPromijenitiPin: boolean
  prava: { mozeStorno: boolean; mozeNaplacivati: boolean; mozePopust: boolean }
}

export interface AdminLoginResponse {
  sessionToken: string
  korisnikId: number
  ime: string
  prezime: string
  adminTip: string
  userSourceTable: string
  companies: Array<{ companyId: number; companyNaziv: string; isDefault: boolean }>
}

export async function getWaitersForDevice(deviceUuid: string): Promise<WaiterListItem[]> {
  return apiRequest(`/auth/waiters?deviceUuid=${deviceUuid}`)
}

export async function loginWaiter(deviceUuid: string, username: string, pin: string): Promise<LoginResponse> {
  return apiRequest("/auth/login", { method: "POST", body: { deviceUuid, username, pin } })
}

export async function loginAdmin(username: string, password: string): Promise<AdminLoginResponse> {
  return apiRequest("/auth/admin/login", { method: "POST", body: { username, password } })
}

export async function logout(token: string): Promise<void> {
  return apiRequest("/auth/logout", { method: "POST", token })
}
